import * as ngCore from '@angular/core'

/**
 * A titled section of content in the page
 */
@ngCore.Component({
  selector: 'atn-summit-pulse-section',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Title for the section
   */
  public readonly titleSg = ngCore.input.required<string>({ alias: 'name' })

  /**
   * Subtitle for the section
   */
  public readonly subtitleSg = ngCore.input<string | undefined>(undefined, {
    alias: 'subtitle',
  })
}
